/**
 * The type of (redux) action which turns the local viewer's drawing mode on
 * the large video on or off.
 *
 * {
 *     type: SET_ANNOTATION_DRAWING,
 *     drawing: boolean
 * }
 */
export const SET_ANNOTATION_DRAWING = 'SET_ANNOTATION_DRAWING';

/**
 * The type of (redux) action by which the local sharer allows or forbids
 * viewers to draw on their screen share.
 *
 * {
 *     type: SET_REMOTE_ANNOTATION_ALLOWED,
 *     allowed: boolean
 * }
 */
export const SET_REMOTE_ANNOTATION_ALLOWED = 'SET_REMOTE_ANNOTATION_ALLOWED';

/**
 * The type of (redux) action by which the local sharer wipes what viewers
 * drew on their screen share, for everyone.
 *
 * {
 *     type: CLEAR_REMOTE_ANNOTATIONS
 * }
 */
export const CLEAR_REMOTE_ANNOTATIONS = 'CLEAR_REMOTE_ANNOTATIONS';
